import React from 'react';


const CallbackHandler = () => <div>Processing signin...</div>;

export default CallbackHandler;

